import ClawGuard, { useClawGuard } from '@tpi-dtd/claw-guard'

export default defineNuxtPlugin((nuxtApp) => {
  const { getDefaultTags } = useClawGuard()

  nuxtApp.vueApp.use(ClawGuard, {
    enable: import.meta.env.DEV,
    tags: [
      ...getDefaultTags(['all', 'error', 'warn', 'info', 'log'])
      // {
      //   color: '#ff0000',
      //   filter: (data) => data.source === 'zod',
      //   symbol: 'zod'
      // }
    ]
  })
})
